module.exports = __webpack_public_path__ + "ci_brand_md.1e737.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_brand_md.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_brand_md.svg
// module chunks = main